export default "__VITE_ASSET__B2CZUmEH__"